
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class SalesReturnItemsDialog extends _Ext.ItemEditorDialog<SalesReturnItemsRow> {
        protected getFormKey() { return SalesReturnItemsForm.formKey; }
        protected getLocalTextPrefix() { return SalesReturnItemsRow.localTextPrefix; }
        protected getDeletePermission() { return SalesReturnItemsRow.deletePermission; }
        protected getInsertPermission() { return SalesReturnItemsRow.insertPermission; }
        protected getUpdatePermission() { return SalesReturnItemsRow.updatePermission; }

        protected form = new SalesReturnItemsForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        // #region Public Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
        public newLineNo: number;
        public Totals: number;
        public HasBom: boolean = true;
        public Closing: boolean;
        public ItemMaster: any;
        // #endregion

        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initBOMEditor(this, this.form.BOMDetails, Config);
            q.initLaborEditor(this, this.form.LaborDetails, Config);

            //Make grid full width
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.ImageName);
            q.hideEditorLabel(this.form.LaborDetails);
            q.hideEditorToolbar(this.form.BOMDetails);
            
            
            //Set Numeric Fields as Right Align
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.DiamondAmount);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.OtherAmount);
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.UnitRate);
            q.setTextRightAlign(this.form.Purity);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.WstPer);
            q.setTextRightAlign(this.form.WstWt);
            q.setTextRightAlign(this.form.UnitLabour);
            // **** Assign Values to BOM and Labor Editor ****



            // **** On Pieces Change Event **** 
            this.form.Pieces.changeSelect2(e => {
                this.form.Pieces.changeSelect2(e => {
                    let pieces = this.form.Pieces.value;
                    let stockdetails = StockHelper.GetStockDetails(this.entity,true,19);
                    if (stockdetails.Pieces > pieces) {

                        this.CalculateTotals();
                        this.CalculateRate();
                    } else {
                        q.alert('', 'Insufficient Stock', true, 2999);
                        this.form.Pieces.value = stockdetails.Pieces;
                    }
                }); 
            });
            // **** On Weight Change Event **** 
            this.form.Weight.changeSelect2(e => {
                let weight = this.form.Weight.value
                if (!isNaN(weight)) {
                    let stockdetails = StockHelper.GetStockDetails(this.entity);
                    if (stockdetails.Weight > weight) {

                        var lbr = this.form.LaborDetails.getItems();
                        var self = this;
                        lbr.forEach(function (x) {
                            x.Weight = self.form.Weight.value;
                            x.Pieces = self.form.Pieces.value;
                            x.LabourAmount = x.CalcOnId == 61 ? self.form.Pieces.value * x.LabourRate : self.form.Weight.value * x.LabourRate;

                        });

                        this.form.LaborDetails.setItems(lbr);
                        this.CalculateRate();
                    } else {
                        q.alert('', 'Insufficient Stock', true, 2999);
                        this.form.Weight.value = stockdetails.Weight;
                    }
                }
            });
            this.form.UnitRate.changeSelect2(e => {
                if (parseInt(this.form.CalcOnId.value) ==3) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    this.form.NetAmount.value = pieces * parseFloat(this.form.UnitRate.value.toString());
                    this.form.GrossAmount.value = this.form.NetAmount.value;
                }
                else if (parseInt(this.form.CalcOnId.value) ==4 || parseInt(this.form.CalcOnId.value) ==5) {
                    var weight = parseFloat(this.form.Weight.value.toString());
                    this.form.NetAmount.value = weight * parseFloat(this.form.UnitRate.value.toString());
                    this.form.GrossAmount.value = this.form.NetAmount.value;
                }
                this.form.CCGrossAmount.value = this.form.GrossAmount.value * this.ExchangeRate;
                this.form.CCNetAmount.value = this.form.NetAmount.value * this.ExchangeRate;
            });

            // **** On NetAmount Change Event **** 
            this.form.NetAmount.changeSelect2(e => {
                var pieces = parseInt(this.form.Pieces.value.toString());
                var netamount = parseFloat(this.form.NetAmount.value.toString());
                this.form.GrossAmount.value = (pieces * netamount);
                this.form.CCGrossAmount.value = this.form.GrossAmount.value * this.ExchangeRate;
                this.form.CCNetAmount.value = this.form.NetAmount.value * this.ExchangeRate;
            });


            //*** BOM row add Edit Delete Event ****
            //Used to Update Amount weight and pieces from BOM to item
            (this.form.BOMDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });

            (this.form.LaborDetails.view as any).onRowCountChanged.subscribe(() => {
                var LAmount = 0;
                var Wst = 0;
                for (var k of this.form.LaborDetails.getItems()) {
                    if (k.ProcessName == "Wastage")
                        Wst += k.WstPer;

                    LAmount += k.LabourAmount;
                }
                this.form.UnitLabour.value = LAmount;
                this.form.WstPer.value = Wst;
                this.form.WstWt.value = this.form.Weight.value * Wst;
                this.form.CCGrossAmount.value = this.form.GrossAmount.value * this.ExchangeRate;
                this.form.CCNetAmount.value = this.form.NetAmount.value * this.ExchangeRate;
            });
            
            // **** On Labor Rate Change Event **** 
            this.form.UnitLabour.changeSelect2(e => {
                this.form.NetAmount.value = parseFloat(this.form.UnitRate.value.toString()) + parseFloat(this.form.UnitLabour.value.toString());
                if (this.form.Pieces.value != null) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    var netamount = parseFloat(this.form.NetAmount.value.toString());
                    this.form.GrossAmount.value = (pieces * netamount);
                }
                this.form.CCGrossAmount.value = this.form.GrossAmount.value * this.ExchangeRate;
                this.form.CCNetAmount.value = this.form.NetAmount.value * this.ExchangeRate;
            });

        }


        protected afterLoadEntity() {
            super.afterLoadEntity();
            if (this.entityId != undefined) {
                if (!this.form.HasBom.value) {
                    this.HasBom = false;
                    q.hideEditorCategory(this.form.BOMDetails);
                    q.hideField(this.form.BOMDetails);
                    this.form.Weight.value = this.entity.Weight == 0 ? 1 : this.entity.Weight;
                }
            }
            this.ItemMaster = (this.parentEditor.parentDialog as SalesReturnMasterDialog);
             
            this.Setfields();
        }

        getItem() {
            return this.getSaveEntity();
        }

        // **** Calculate Amount, Tax etc ****
        CalculateTotals() {
            if (this.form.ItemTypeId.value != null) {
                var Pcs = 0, Wt = 0, othrpcs = 0, othrwt = 0, clrpcs = 0, clrwt = 0, diapcs = 0, diawt = 0, grswt = 0, cts = 0, gms = 0, rate = 0;
                var labrate = 0.00; var wstper = 0; var wstwt = 0;
                for (var k of this.form.BOMDetails.getItems()) {

                    if (k.ItemTypeId == 104) {
                        Wt += k.Weight;
                    }
                    if (k.ItemTypeId == 105 && k.CalcOnId == 5) {
                        cts += k.Weight;
                        diapcs += k.Pieces
                    }
                    if (k.ItemTypeId == 105 && k.CalcOnId == 4) {
                        gms += k.Weight;
                        clrpcs += k.Pieces;
                    }

                    rate += k.BomAmount;

                }
                for (var i of this.form.LaborDetails.getItems()) {

                    labrate += i.LabourAmount;
                    wstper += i.WstPer || 0;
                    wstwt += i.WstWt || 0;

                }

                this.form.NetWeight.value = Wt;
                this.form.OtherPieces.value = othrpcs || 0;
                this.form.StonePieces.value = clrpcs || 0;
                this.form.StoneWeight.value = gms;
                this.form.DiamondPieces.value = diapcs || 0;
                this.form.DiamondWeight.value = cts || 0;
                this.form.OtherWeight.value = 0;
                this.form.WstPer.value = wstper;
                this.form.WstWt.value = wstwt;
                this.form.UnitLabour.value = labrate;

                if (cts > 0)
                    this.form.Weight.value = Wt + gms + (cts / 5);
                else
                    this.form.Weight.value = Wt + gms;
                this.form.UnitRate.value = rate / this.form.Pieces.value;
                this.form.NetAmount.value = this.form.UnitRate.value + this.form.UnitLabour.value;

                if (this.form.Pieces.value != null) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    var netamount = parseFloat(this.form.NetAmount.value.toString());
                    this.form.GrossAmount.value = (pieces * netamount);
                }

                if (!this.HasBom && this.entity.ItemTypeId == 101) {
                    this.form.Weight.value = this.entity.Weight == 0 ? 1 : this.entity.Weight;
                    this.form.NetWeight.value = this.entity.NetWeight;
                    this.form.UnitRate.value = this.entity.UnitRate;
                    this.form.NetAmount.value = this.entity.UnitRate * this.entity.Weight;
                    this.form.GrossAmount.value = this.entity.UnitRate * this.entity.Weight;
                }
            }
            this.form.CCGrossAmount.value = this.form.GrossAmount.value * this.ExchangeRate;
            this.form.CCNetAmount.value = this.form.NetAmount.value * this.ExchangeRate;
        }


        private Setfields() {

            Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
            q.showAndDisableField(this.form.ProductTypeId);
            q.showAndDisableField(this.form.ProductCode);
            q.showAndDisableField(this.form.HSN);
            q.showAndDisableField(this.form.ProductName);
            // **** Hide Jewellery Fields **** //
            if (this.form.ItemTypeId.value != 101) {
                q.hideField(this.form.BOMDetails);
                q.hideField(this.form.BrandId);
                q.hideField(this.form.CollectionId);
                q.hideField(this.form.SuperTypeId);
                q.hideField(this.form.ProductSizeId);
                q.hideField(this.form.UnitLabour);
                q.hideField(this.form.NetWeight);
                q.hideField(this.form.DiamondPieces);
                q.hideField(this.form.DiamondWeight);
                q.hideField(this.form.StonePieces);
                q.hideField(this.form.StoneWeight);
                q.hideField(this.form.OtherWeight);
                q.hideField(this.form.OtherPieces);
                q.hideField(this.form.WstPer);
                q.hideField(this.form.WstWt);
                //  q.hideField(this.form.StockId);
                q.hideField(this.form.Line_No);
                q.hideField(this.form.SKU);
                q.hideField(this.form.CategoryId);
                //  q.hideField(this.form.RefVoucherId);
                q.hideEditorTab(this.form.BOMDetails);
                q.hideEditorTab(this.form.ImageName);

                // **** Metal Fields **** //
                if (this.form.ProductTypeId.value == "5" || this.form.ProductTypeId.value == "6" || this.form.ProductTypeId.value == "7") {
                    q.showAndDisableField(this.form.KaratId);
                    q.showAndDisableField(this.form.MetalColorId);
                    q.showAndDisableField(this.form.Purity);

                    q.hideField(this.form.ShapeId);
                    q.hideField(this.form.QualityId);
                    q.hideField(this.form.StoneColorId);
                    q.hideField(this.form.StoneSizeId);

                    if (this.form.ItemTypeId.value == 0)
                        this.form.ItemTypeId.value = 104;

                    if (this.form.CategoryId.value.length == 0)
                        this.form.CategoryId.value = "123";

                    switch (this.form.ProductTypeId.value) {
                        case "5":
                            this.form.SubCategoryId.value = "301";
                            break;
                        case "6":
                            this.form.SubCategoryId.value = "302";
                            break;
                        case "7":
                            this.form.SubCategoryId.value = "303";
                            break;
                    }

                }

                // **** Metal Fields **** //
                if (this.form.ProductTypeId.value == "11" || this.form.ProductTypeId.value == "12" || this.form.ProductTypeId.value == "13") {
                    q.showAndDisableField(this.form.SubCategoryId);
                    q.showAndDisableField(this.form.ShapeId);
                    q.showAndDisableField(this.form.QualityId);
                    q.showAndDisableField(this.form.StoneColorId);
                    q.showAndDisableField(this.form.StoneSizeId);


                    q.hideField(this.form.KaratId);
                    q.hideField(this.form.MetalColorId);
                    q.hideField(this.form.Purity);


                    if (this.form.ItemTypeId.value == 0)
                        this.form.ItemTypeId.value = 105;

                    if (this.form.CategoryId.value.length == 0)
                        this.form.CategoryId.value = "124";
                    this.form.SieveId.value = "131";

                    if (this.form.SubCategoryId.value == "348") {
                        q.hideField(this.form.StoneCutId);
                        q.hideField(this.form.StonePolishId);
                        q.hideField(this.form.StoneSymmetryId);
                        q.hideField(this.form.StoneFluorescenceId);
                        q.hideField(this.form.StoneCuletId);
                        q.hideField(this.form.StoneGirdleId);
                        q.hideField(this.form.StoneTable);
                        q.hideField(this.form.StoneDepth);
                        q.hideField(this.form.CertificateNo);

                    }
                    // **** Solitaire **** //
                    if (this.form.SubCategoryId.value == "349") {
                        q.showAndDisableField(this.form.StoneCutId);
                        q.showAndDisableField(this.form.StonePolishId);
                        q.showAndDisableField(this.form.StoneSymmetryId);
                        q.showAndDisableField(this.form.StoneFluorescenceId);
                        q.showAndDisableField(this.form.StoneCuletId);
                        q.showAndDisableField(this.form.StoneGirdleId);
                        q.showAndDisableField(this.form.StoneTable);
                        q.showAndDisableField(this.form.StoneDepth);
                        q.showAndDisableField(this.form.CertificateNo);
                        q.showAndDisableField(this.form.Pieces);
                        q.showAndDisableField(this.form.Weight);
                        q.showAndDisableField(this.form.Lab);

                    }
                }
            }
            else {

                q.showAndDisableField(this.form.BOMDetails);
                q.showAndDisableField(this.form.BrandId);
                q.showAndDisableField(this.form.CollectionId);
                q.showAndDisableField(this.form.SuperTypeId);
                q.showAndDisableField(this.form.ProductSizeId);
                q.showAndDisableField(this.form.UnitLabour);
                q.showAndDisableField(this.form.NetWeight);
                q.showAndDisableField(this.form.DiamondPieces);
                q.showAndDisableField(this.form.DiamondWeight);
                q.showAndDisableField(this.form.StonePieces);
                q.showAndDisableField(this.form.StoneWeight);
                q.showAndDisableField(this.form.OtherWeight);
                q.showAndDisableField(this.form.OtherPieces);
                q.showAndDisableField(this.form.WstPer);
                q.showAndDisableField(this.form.WstWt);
                //  q.hideField(this.form.StockId);
                q.showAndDisableField(this.form.Line_No);
                q.showAndDisableField(this.form.SKU);
                q.showAndDisableField(this.form.CategoryId);
            }

        } 
    }
}